import { render, staticRenderFns } from "./chat-box.vue?vue&type=template&id=b0276b96&"
import script from "./chat-box.vue?vue&type=script&lang=js&"
export * from "./chat-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports